import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { asyncFilter } from '@/util/common';
import Home from '../views/Home.vue';
import authService from "@/services/auth";

Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue'),
  },
  {
    path: '/notfound',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue'),
  },
  {
    path: '/fraud-cases',
    name: 'fraud-cases',
    meta: {
      drawer: true,
      authority: 'tdrs',
      icon: 'mdi-account-alert'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/FraudCases.vue'),
  },
  {
    path: '/messages',
    name: 'messages',
    meta: {
      drawer: true,
      authority: 'messages',
      icon: 'mdi-message'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Messages.vue'),
  },
  {
    path: '/analysis',
    name: 'analysis',
    meta: {
      drawer: true,
      authority: 'messages',
      icon: 'mdi-owl'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/MsisdnAnalysis.vue'),
  },
  {
    path: '/transactions',
    name: 'transactions',
    meta: {
      drawer: true,
      authority: 'messages',
      icon: 'mdi-owl'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Transactions.vue'),
  },
  {
    path: '/analysis-transaction',
    name: 'analysis-transaction',
    meta: {
      drawer: true,
      authority: 'messages',
      icon: 'mdi-owl'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/TransactionAnalysis.vue'),
  },
  {
    path: '/whatsapp',
    name: 'whatsapp',
    meta: {
      drawer: true,
      authority: 'messages',
      icon: 'mdi-whatsapp'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/WhatsAppList.vue'),
  },
  {
    path: '/messages/:id',
    name: 'message',
    meta: {
      drawer: false,
      authority: 'messages'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Message.vue'),
  },
  {
    path: '/conversation',
    name: 'conversation',
    meta: {
      drawer: false,
      authority: 'messages'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/WhatsAppConversation.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

